import React from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Typography,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { pluralize } from "../../../utils/a11y/ptBr";

const SELECT_ALL_LABEL_ID = "culturehub-select-all-label";

const CultureHubToolbar = ({
  selectedCount,
  isAllSelected,
  onToggleAll,
  showOnlyAssessment,
  onToggleAssessment,
  onUploadAssessment,
  onDownload,
  isDownloading,
}) => {
  const hasSelection = selectedCount > 0;
  const isPartiallySelected = hasSelection && !isAllSelected;

  return (
    <Box
      sx={{
        minHeight: "40px",
        px: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "48px auto",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Checkbox
              size="small"
              checked={isAllSelected}
              onChange={onToggleAll}
              // native indeterminate: announced as "mixed" without changing the visual icon
              inputRef={(input) => {
                if (input) input.indeterminate = isPartiallySelected;
              }}
              inputProps={{ "aria-labelledby": SELECT_ALL_LABEL_ID }}
            />
          </Box>

          <Typography
            id={SELECT_ALL_LABEL_ID}
            sx={{
              fontSize: "14px",
              color: "#666666",
            }}
          >
            {hasSelection
              ? `${String(selectedCount).padStart(2, "0")} ${pluralize(
                  selectedCount,
                  "selecionado",
                  "selecionados"
                )}`
              : "Selecionar todos"}
          </Typography>
        </Box>

        {!hasSelection && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<FilterAltOutlinedIcon />}
            onClick={onToggleAssessment}
            sx={{
              textTransform: "none",
              color: "#185CFB",
              borderColor: "#E2E2E3",
            }}
          >
            {showOnlyAssessment
              ? "Mostrar Todos"
              : "Mostrar Apenas Parecer"}
          </Button>
        )}
      </Box>

      {hasSelection && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Button
            variant="outlined"
            size="small"
            startIcon={
              isDownloading ? (
                <CircularProgress size={16} aria-hidden="true" />
              ) : (
                <DownloadOutlinedIcon />
              )
            }
            onClick={onDownload}
            disabled={isDownloading}
            aria-busy={isDownloading}
            sx={{ textTransform: "none", color: "#185CFB", borderColor: "#E2E2E3" }}
          >
            Baixar
          </Button>

          <Button
            variant="outlined"
            size="small"
            startIcon={<ShareOutlinedIcon />}
            disabled
            sx={{ textTransform: "none", color: "#185CFB", borderColor: "#E2E2E3" }}
          >
            Compartilhar
          </Button>

          <Button
            variant="outlined"
            size="small"
            startIcon={<UploadOutlinedIcon />}
            onClick={onUploadAssessment}
            sx={{ textTransform: "none", color: "#185CFB", borderColor: "#E2E2E3" }}
          >
            Upload de Parecer
          </Button>

          <Button
            variant="outlined"
            size="small"
            disabled
            sx={{ textTransform: "none", color: "#185CFB", borderColor: "#E2E2E3" }}
          >
            Dispensar Parecer
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default CultureHubToolbar;